import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "type", "children"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import styles from "./styles.pcss";
var cnGrid = cnBem('grid', styles);
export var Grid = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'days' : _ref$type,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnGrid({
      type: type
    }, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "DatePicker-Grid"
  }), children);
});